import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';

function OtherStock() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const [totalopbal, setTotalopbal] = useState(0);
    const [totalp, setTotalp] = useState(0);
    const [totalprtn, setTotalprtn] = useState(0);
    const [totals, setTotals] = useState(0);
    const [totalsrtn, setTotalsrtn] = useState(0);
    const [totalstin, setTotalsint] = useState(0);
    const [totalstout, setTotalstout] = useState(0);
    const [totalrpl, setTotalrpl] = useState(0);
    const [totalcls, setTotalcls] = useState(0);
    const [totalstkval, setTotalstkval] = useState(0);
    const [totalsalval, setTotalsalval] = useState(0);

    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branchId, setBranch] = useState(0);
    const [branchName, setBranchName] = useState(0);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
        fetchBranchData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const handleBranchSelect = (selectedOption) => {
        setSelectedBranch(selectedOption);
        const branchId = selectedOption ? selectedOption.value : '';
        setBranch(branchId);

        const branchName = selectedOption ? selectedOption.label : '';
        setBranchName(branchName);

        setDataItem([])
    };

    const fetchBranchData = () => {
        fetchData('ReportApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setBranchOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };

    useEffect(() => {
        // Calculate total 
        let totalopbal = 0;
        let totalp = 0;
        let totalprtn = 0;
        let totals = 0;
        let totalsrtn = 0;
        let totalstin = 0;
        let totalstout = 0;
        let totalrpl = 0;
        let totalcls = 0;
        let totalstkval = 0;
        let totalsalval = 0;


        dataItem.forEach(item => {
            totalopbal += item.OpeningQty;
            totalp += item.PurchaseQty;
            totalprtn += item.PurchaseReturnQty;
            totals += item.SaleQty;
            totalsrtn += item.SaleReturnQty;
            totalstin += item.StockInQty;
            totalstout += item.StockOutQty;
            totalrpl += item.ReplaceQty;
            totalcls += item.ClosingQty;
            totalstkval += item.StockValue;
            totalsalval += item.SaleValue;
        });
        setTotalopbal(totalopbal);
        setTotalp(totalp);
        setTotalprtn(totalprtn);
        setTotals(totals);
        setTotalsrtn(totalsrtn);
        setTotalsint(totalstin);
        setTotalstout(totalstout);
        setTotalrpl(totalrpl);
        setTotalcls(totalcls);
        setTotalstkval(totalstkval);
        setTotalsalval(totalsalval);
    }, [dataItem]);

    const fetchCustomerData = () => {

    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            if (!branchId) {
                return;
            }
            try {
                const response = await fetchData('ReportApi', `/Stock/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Stock Details:', error);
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const excelData = [];
        const headerCaption = [`${branchName} Consolidated Stock From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        excelData.push(headerCaption);
        const headerRow = ['Code', 'Item', 'Opening', 'Purchase', 'Purchase Return', 'Sale', 'Sale Return', 'Stock In', 'Stock Out', 'Replacement', 'Closing', 'Purchase Rate', 'MRP', 'Stock Value', 'Sale Value', 'GST%', 'HSN Code'
            , 'PG', 'IG', 'ISG', 'PF', 'Disc%', 'Category', 'PG Category', 'Item Group'
        ];
        excelData.push(headerRow);
        filteredDataItem.forEach((rowData, index) => {
            const dataRow = [];
            dataRow.push(rowData.Code, rowData.Name, rowData.OpeningQty, rowData.PurchaseQty, rowData.PurchaseReturnQty, rowData.SaleQty, rowData.SaleReturnQty, rowData.StockInQty, rowData.StockOutQty, rowData.ReplaceQty
                , rowData.ClosingQty, rowData.PurchaseRate.toFixed(2), rowData.MRP.toFixed(2), rowData.StockValue.toFixed(2), rowData.SaleValue.toFixed(2), rowData.GSTRate, rowData.HSNCode, rowData.PG, rowData.IG, rowData.ISG, rowData.PF, rowData.DiscountPercentage, rowData.CategoryName, rowData.PGCategoryName, rowData.ItemGroupName);
            excelData.push(dataRow);
        });
        // Add total row
        const totalRow = ['', 'Total', totalopbal, totalp, totalprtn, totals, totalsrtn, totalstin, totalstout, totalrpl, totalcls, , , totalstkval, totalsalval, '', '', '', ''];
        excelData.push(totalRow);
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Stock');
        XLSX.writeFile(wb, 'Consolidated Stock.xlsx');
    };

    const handlePrint = () => {

    };

    const branchOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...branchOptions];
    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h5 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        Consolidated STOCK
                    </h5>
                </div>

                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            <RefreshIcon style={{ color: 'brown' }} />
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            <FeedIcon style={{ color: 'darkgreen' }} />
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder' }}>Excel</span>
                    </Button>

                    <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px', width: '275px' }}
                            />
                        )}
                    </div>
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>


                <div style={{ width: '100%', maxWidth: '30%', marginLeft: '10px', paddingRight: '5', marginRight: '10px', marginBottom: '2', flexBasis: 'auto' }}>

                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        Branch
                        <span style={{ color: 'red' }}>*</span>
                    </label>

                    <Select
                        options={branchOptionsWithBlank}
                        value={selectedBranch}
                        onChange={handleBranchSelect}
                        placeholder="Select a Branch"
                        style={{ width: '100%', marginTop: '-11px' }}
                    />
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Code</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Item</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Opening</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Purchase</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Purchase Return</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Sale</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Sale Return</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Stock In</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Stock Out</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Replacement</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Closing</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Purchase Rate</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>MRP</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Stock Value</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Sale Value </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>GST%</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>HSN Code</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>PG</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>IG</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>ISG</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>PF</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Disc%</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Category</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>PG Category</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Item Group</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: '#24203C' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        padding: '7px',
                                        height: '52px',

                                        backgroundColor: 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Code}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.OpeningQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.PurchaseQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.PurchaseReturnQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.SaleQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.SaleReturnQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.StockInQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.StockOutQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.ReplaceQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.ClosingQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.PurchaseRate.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.MRP.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.StockValue.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.SaleValue.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.GSTRate}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.HSNCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.IG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.ISG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PF}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.DiscountPercentage}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.CategoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PGCategoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.ItemGroupName}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '52px',

                                    backgroundColor: 'teal',

                                }}
                            >
                                <TableCell colSpan={2} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalopbal}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalp}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalprtn}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totals}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalsrtn}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalstin}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalstout}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalrpl}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalcls}</TableCell>
                                <TableCell colSpan={2} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalstkval.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalsalval.toFixed(2)}</TableCell>
                                <TableCell colSpan={10} />
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

        </div>
    );
}

export default OtherStock;
